import gsap from "gsap";
import getHiddenElementHeight from "../utils/getHiddenElementHeight.util";

export class AccordionSection {
    private accordionItems: NodeListOf<HTMLElement>;

    constructor(private readonly root: HTMLElement) {
        this.accordionItems = this.root.querySelectorAll<HTMLElement>(".accordion-item");
    }

    public init = () => {
        this.accordionItems.forEach((item) => {
            this.listeners(item);
        });
    };

    private handler = ({ currentTarget, target }: MouseEvent) => {
        const item = currentTarget as HTMLElement;
        const currentElement = target as HTMLElement;
        const bodyElement = item.querySelector<HTMLElement>(".accordion-item__body");
        const currentHeight = getHiddenElementHeight(bodyElement);

        if (bodyElement && bodyElement.contains(currentElement)) return;

        if (!item.classList.contains("active")) {
            gsap.fromTo(bodyElement, { height: 0 }, { height: currentHeight, duration: 0.2 });
            item.classList.add("active");
        } else {
            gsap.to(bodyElement, { height: 0, duration: 0.2 });
            item.classList.remove("active");
        }
    };

    private listeners = (item: HTMLElement) => {
        item.addEventListener("click", this.handler);
    };
}
